import { INVENTORY_CATALOG, type CatalogTrack } from "@/lib/inventoryCatalog";

const SYNONYMS: Record<string, string> = {
  mug: "Cups",
  mugs: "Cups",
  cup: "Cups",
  glasses: "Cups",
  tumblers: "Cups",
  wineglasses: "Cups",
  "wine glasses": "Cups",
  tp: "Toilet paper",
  "toilet roll": "Toilet paper",
  "toilet rolls": "Toilet paper",
  "paper towel": "Paper towels",
  "dish liquid": "Dish soap",
  "washing up liquid": "Dish soap",
  forks: "Utensils",
  spoons: "Utensils",
  knives: "Utensils",
  cutlery: "Utensils",
  "trash bags": "Garbage bags",
  "all purpose cleaner": "All-purpose cleaner",
  "multi purpose cleaner": "All-purpose cleaner",
  "multi-purpose cleaner": "All-purpose cleaner",
  "multipurpose cleaner": "All-purpose cleaner",
  "bin bags": "Garbage bags",
  pods: "Dishwasher pods",
  "dishwasher tablets": "Dishwasher pods",
  "hand towels": "Hand towels",
  "bath towel": "Bath towels",
  towels: "Bath towels",
};

function norm(s: string): string {
  return s.trim().toLowerCase().replace(/[·.]/g, " ").replace(/\s+/g, " ");
}

export function matchInventoryCatalog(name: string): { name: string; track: CatalogTrack } {
  const n = norm(name);
  const mapped = SYNONYMS[n];
  const catalog = INVENTORY_CATALOG.find((c) => norm(c.name) === n || c.name === mapped);
  if (catalog) return { name: catalog.name, track: catalog.track };
  if (mapped) {
    const hit = INVENTORY_CATALOG.find((c) => c.name === mapped);
    if (hit) return { name: hit.name, track: hit.track };
  }
  const contains = INVENTORY_CATALOG.find(
    (c) => n.includes(norm(c.name)) || norm(c.name).includes(n),
  );
  if (contains) return { name: contains.name, track: contains.track };
  return { name: name.trim(), track: "units" };
}

const LEVEL_MAP: Record<string, number> = {
  full: 1,
  "3/4": 0.75,
  "1/2": 0.5,
  "1/4": 0.25,
  empty: 0,
  half: 0.5,
  low: 0.25,
};

export function parseSpokenLevel(raw: string | null | undefined): number | null {
  if (!raw) return null;
  const key = raw.trim().toLowerCase();
  if (key in LEVEL_MAP) return LEVEL_MAP[key]!;
  return null;
}

/** Slice 28: Count Low at = half of Now, min 1. Level Low at = ¼. */
export function inventoryNowAndLow(input: {
  track: CatalogTrack;
  spokenNumber: number | null;
  spokenLevel: string | null;
}): {
  quantityType: CatalogTrack;
  currentCount: number;
  thresholdCount: number | null;
  currentValue: number | null;
  thresholdValue: number | null;
} {
  if (input.track === "fullness") {
    const now = parseSpokenLevel(input.spokenLevel) ?? 1;
    return {
      quantityType: "fullness",
      currentCount: 0,
      thresholdCount: null,
      currentValue: now,
      thresholdValue: 0.25,
    };
  }
  const now = input.spokenNumber != null && input.spokenNumber >= 0 ? input.spokenNumber : 0;
  const low = Math.max(1, Math.floor(now / 2));
  return {
    quantityType: "units",
    currentCount: now,
    thresholdCount: low,
    currentValue: null,
    thresholdValue: null,
  };
}
